import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import axios from "axios";

export const useAdminPageStore = defineStore('admin-page-store',  () => {

  const fullUserList = ref([])
  function getFullUserList() {
    axios.get(`/api/users`).then(r => { fullUserList.value = r.data })
  }

  const invitedUsers = ref([])
  function getInvitedUsers() {
    axios.get(`/api/invited_users`).then(r => { invitedUsers.value = r.data })
  }

  function updateUser(userId, userChanges) {
    axios.patch(`/api/users/${userId}`, userChanges).then(r => { fullUserList.value = r.data })
  }

  function inviteUsers(emails) {
    axios.post(`/api/invited_users`, { emails }).then(r => { invitedUsers.value = r.data })
  }

  function uninviteUser(userId) {
    axios.delete(`/api/invited_users/${userId}`).then(r => { invitedUsers.value = r.data })
  }

  function resendInvitation(userId) {
    axios.post(`/api/invited_users/${userId}/resend`)
  }

  function blockUser(userId) {
    axios.post(`/api/users/${userId}/block`).then(r => { fullUserList.value = r.data })
  }

  function unblockUser(userId) {
    axios.post(`/api/users/${userId}/unblock`).then(r => { fullUserList.value = r.data })
  }

  const blockedUsers = computed(() => {
    return fullUserList.value.filter(user => user.blocked)
  })

  const activeUsers = computed(() => {
    return fullUserList.value.filter(user => (!user.blocked))
  })

  return {
    blockedUsers,
    invitedUsers,
    activeUsers,
    fullUserList,
    getFullUserList,
    getInvitedUsers,
    updateUser,
    uninviteUser,
    resendInvitation,
    inviteUsers,
    blockUser,
    unblockUser
  }
})
